import Model3d from "oc-modules/oc-jaco3d/arrangement3d/Model3d";
import { App } from "../App";
import { fabric } from "fabric";
import Commons from "oc-commons/Commons";

export default class Booth3d extends Model3d {
  constructor(props) {
    super(props);
    this.defaultCanvasSize = 512; //aka resolution of texture
    // ich hasse class-components, ohne die folgenden Zeilen ist "this" in den Funktionen undefined
    this.prepareCanvas = this.prepareCanvas.bind(this);
    this.updateCanvasTexture = this.updateCanvasTexture.bind(this);
    this.prepareTextCanvas = this.prepareTextCanvas.bind(this);
    this.updateMaterial = this.updateMaterial.bind(this);
    APP.on("ready", () => {
      this.prepareCanvases();
      this.updateTextCanvas();
      this.update3dMaterials();
    });
  }

  update3d() {
    super.update3d();
    this.update3dMaterials();
  }

  transformObject3dAfterLoad(object, options) {
    super.transformObject3dAfterLoad(object, options);
    this.posters = Scenes.filter(object, (o) => o.material?.name.match(/^poster/i)).map(o => o.material.name).sort().map(p=>p.toLowerCase());
    this.logos = Scenes.filter(object, (o) => o.material?.name.match(/^logo/i)).map(o => o.material.name).sort().map(p=>p.toLowerCase());
    console.log('found graphics ', this.posters, this.logos);

    const setup = (field) => {
      const num = field.charAt(field.length - 1);
      if(!APP.arrangement.state[field]) {
        APP.arrangement.state[field] = {
          url: "",
          x: 50,
          y: 50,
          zoom: 50
        }
      }
      this[field] = {};
      this[field].exists = true;
      this[field].defaultScale = 1;
      this[field].ref = Scenes.find(object, mesh => mesh.material?.name.toLowerCase() == field);
      this[field].ref.material.defaultMap = _.cloneDeep(this[field].ref.material.map);
      const size = this[field].ref.posbox.size;
      this[field].sizeFactor = size.z < size.x ? size.y / size.x : size.y / size.z;
      this.createCanvasForField(field);
    }
    this.posters.forEach( posterName => setup(posterName));
    this.logos.forEach( logoName => setup(logoName));

    // this.fields.forEach((field) => {
    //   this[field] = { exists: false };
    //   const num = field.charAt(field.length - 1);
    //   const correctArray = Scenes.filter(object, (o) =>
    //     o.material?.name.toLowerCase().contains(field.slice(0, -1))
    //   );
    //   if (correctArray?.find((mesh) => mesh.material?.name.contains(num))) {
    //     this[field].exists = true;
    //     this[field].defaultScale = 1;
    //     this[field].ref = correctArray?.find((mesh) => mesh.material?.name.contains(num));
    //     this[field].ref.material.defaultMap = _.cloneDeep(this[field].ref.material.map);
    //     const size = this[field].ref.posbox.size;
    //     this[field].sizeFactor = size.z < size.x ? size.y / size.x : size.y / size.z;
    //     this.createCanvasForField(field);
    //   }
    // });

    this.companyName = { exists: false };
    if (
      Scenes.filter(object, (o) => o.material?.name.toLowerCase().contains("company")).length > 0
    ) {
      this.companyName.exists = true;
      this.companyName.ref = Scenes.filter(object, (o) =>
        o.material?.name.toLowerCase().contains("company")
      )[0];
      this.companyName.defaultTexture = _.cloneDeep(this.companyName.ref.material.map);
      const size = this.companyName.ref.posbox.size;
      this.companyName.sizeFactor = size.z < size.x ? size.y / size.x : size.y / size.z;
    }

    return object;
  }

  createCanvasForField(field) {
    if(!$(`canvas#${field}Div`)[0]) $("body").append(`<canvas id="${field}Div"></canvas>`);
    this[field].textureCanvas = new fabric.Canvas(`${field}Div`);
    this[field].textureCanvas.setWidth(this.defaultCanvasSize);
    this[field].textureCanvas.setHeight(this.defaultCanvasSize * this[field].sizeFactor);
  }

  prepareCanvases() {
    this.posters.forEach((field) => {
      if (this[field]?.exists) {
        this.createCanvasForField(field);
        this.prepareCanvas(field); //, 300, field);
      }
    });
    this.logos.forEach((field) => {
      if (this[field]?.exists) {
        this.createCanvasForField(field);
        this.prepareCanvas(field); //, 300, field);
      }
    });

    if (this.companyName?.exists) {
      // kann man aus irgend einem Grund nicht in prapareCanvas packen :/
      if(!$('canvas#companyNameDiv')[0]) $("body").append('<canvas id="companyNameDiv"></canvas>');
      this.companyName.textureCanvas = new fabric.Canvas("companyNameDiv");
      this.companyName.textureCanvas.backgroundColor = "white";
      // zum debuggen:
      // this.companyName.textureCanvas.on({
      //   "object:moving": _.debounce(this.updateMaterial, 10)
      // })
      this.companyName.textureCanvas.setWidth(this.defaultCanvasSize * 2);
      this.companyName.textureCanvas.setHeight(
        this.defaultCanvasSize * 2 * this.companyName.sizeFactor
      );
      this.prepareTextCanvas(); //, 300);
    }
  }

  updateMaterial() {
    const textureCanvas = this.companyName.textureCanvas;
    const canvasTexture = this.companyName.texture;
    textureCanvas.renderAll();
    if (canvasTexture) canvasTexture.needsUpdate = true;
    STAGE.dirty();
  }

  prepareTextCanvas() {
    if (this.companyName.exists) {
      this.companyName.textureCanvas.backgroundColor = "white";
      this.companyName.texture = new THREE.CanvasTexture(
        this.companyName.textureCanvas.getElement(),
        THREE.UVMapping
      );
      this.companyName.texture.flipY = false;
      this.companyName.ref.material.map = this.companyName.texture;
      const text = APP.arrangement.state.companyName;
      const color = APP.arrangement.state.companyColor;
      const canvasText = new fabric.Text(text || I18N("default company name"), {
        // textobject von Fabric js
        left: this.defaultCanvasSize,
        top: this.defaultCanvasSize * this.companyName.sizeFactor,
        originX: "center",
        originY: "center",
        fill: color || "black",
        fontSize: (APP.settings.canvasFontSize || 144) * (this.defaultCanvasSize/1024),
      });
      this.companyName.textureCanvas?.clear(); // vlt nicht??
      this.companyName.textureCanvas.add(canvasText);
      _.delay(() => {
        this.companyName.textureCanvas.backgroundColor = "white";
        this.companyName.textureCanvas.renderAll();
        this.companyName.ref.material.map.needsUpdate = true;
        this.companyName.ref.material.color = new THREE.Color(0xffffff);
        STAGE.dirty();
      }, 300);
    }
  }

  // wird bei Text/Farb Wechsel aufgerufen
  updateTextCanvas() {
    if (!this.companyName.textureCanvas) this.prepareCanvases();
    if (this.companyName?.exists) {
      // commenting in the following will return default texture if no text is entered, right now this does not allow re-writing
      /* if (!APP.arrangement.state.companyName) {
        this.companyName.textureCanvas?.clear();
        this.companyName.ref.material.map = this.companyName.defaultTexture;
        this.updateMaterial();
      }
      else */ if (this.companyName.textureCanvas._objects[0]) {
        this.companyName.textureCanvas.backgroundColor = "white";
        if (APP.arrangement.state.companyColor != this.companyName.textureCanvas._objects[0].fill) {
          this.prepareTextCanvas();
        } else {
          const text = APP.arrangement.state.companyName;
          if (text !== undefined && text !== null) {
            this.companyName.textureCanvas._objects[0].text = text.trim();
            this.companyName.textureCanvas.backgroundColor = "white";
            this.companyName.textureCanvas.renderAll();
            this.updateMaterial();
          }
        }
      }
    }
  }

  prepareCanvas(field) {
    if (this[field].exists) {
      if (!APP.arrangement.state[field]?.url) {
        this[field].textureCanvas?.clear();
        this[field].ref.material.map = _.cloneDeep(this[field].ref.material.defaultMap);
        this[field].ref.material.needsUpdate = true;
        STAGE.dirty();
      } else {
        this[field].texture = new THREE.CanvasTexture(
          this[field].textureCanvas.getElement(),
          THREE.UVMapping
        );
        this[field].texture.flipY = false;
        this[field].ref.material.map = this[field].texture;
        const url = APP.contentUrl + "/" + APP.arrangement.state[field].url;
        fabric.Image.fromURL(url, (i) => {
          // image dimensions
          const ih = i.height;
          const iw = i.width;
          // finding the correct Scale for the Canvas
          this[field].defaultScale =
            this.defaultCanvasSize / iw > (this[field].sizeFactor * this.defaultCanvasSize) / ih
              ? (this[field].sizeFactor * this.defaultCanvasSize) / ih
              : this.defaultCanvasSize / iw;
          // resizing the image keeping correct aspect ratio
          i.scaleX = this[field].defaultScale;
          i.scaleY = this[field].defaultScale;
          i.originX = "center";
          i.originY = "center";
          const spaceOnX = i.scaleX * iw < this.defaultCanvasSize;
          this[field].initialLeft =
            (iw * i.scaleX) / 2 + (spaceOnX ? (this.defaultCanvasSize - iw * i.scaleX) / 2 : 0);
          this[field].initialTop =
            (ih * i.scaleY) / 2 +
            (spaceOnX ? 0 : (this[field].sizeFactor * this.defaultCanvasSize - ih * i.scaleY) / 2);
          this[field].textureCanvas.clear();
          this[field].textureCanvas.backgroundColor = "white";
          this[field].textureCanvas.add(i);
        });
        Commons.delayUntil(
          () => {
            this.updateCanvasTexture(field);
            this[field].ref.material.needsUpdate = true;
          },
          () => this[field].textureCanvas._objects.length > 0,
          2000
        );
      }
    }
  }

  updateCanvasTexture(field) {
    if (this[field].exists) {
      // APP.arrangement.booth.jaco3d[field].textureCanvas?.clear(); // wird wohl nicht mehr benötigt
      // offset
      this[field].textureCanvas._objects[0].left =
        10 * APP.arrangement.state[field].x - 500 + this[field].initialLeft;
      this[field].textureCanvas._objects[0].top =
        -10 * APP.arrangement.state[field].y + 500 + this[field].initialTop;
      // zoom normalised --> 0 is 1/3, 50 is default, 100 is 5/3
      this[field].textureCanvas._objects[0].scaleX =
        this[field].defaultScale / 3 +
        ((APP.arrangement.state[field].zoom / 50) * this[field].defaultScale * 2) / 3;
      this[field].textureCanvas._objects[0].scaleY =
        this[field].defaultScale / 3 +
        ((APP.arrangement.state[field].zoom / 50) * this[field].defaultScale * 2) / 3;
      this[field].textureCanvas.renderAll();
      this[field].texture.needsUpdate = true;
    }
    STAGE.dirty();
  }

  update3dMaterials() {
    //TODO: key.changed? Performance!
    if (this.jaco?.state?.boothColors) {
      this.traverse((o3) => {
        const boothColor = this.jaco.state.boothColors.find(
          (sC) => sC.colorPrefix === o3.material?.name.toLowerCase()
        );
        if (boothColor) {
          o3.material.color = boothColor.color;
        }
      });
    }
  }

  resetTextures() {
    this.fields.forEach((field) => {
      if (this[field] && this[field].ref?.material)
        this[field].ref.material.map = this[field].ref.material.defaultMap;
      this[field].ref.material.needsUpdate = true;
    });
  }

  onLoadModel() {
    super.onLoadModel();
    this.update3dMaterials();
    this.jaco.compileFloorRestraints();
  }
}
